//import StyleSheet from "react-stylesheet";
//import Text from "react-text";
import Icon from "react-web-vector-icons";
import React from "react";
import ilockit from "./ilockit.json";
import * as commonStyles from "../commonStyles/common";

const BatteryIcon = ({ batteryValue }) => {
  if (typeof batteryValue !== "number") {
    return <> </>;
  }

  let roundedBatteryValue = Math.ceil(batteryValue / 10) * 10;
  const batteryColor =
    batteryValue > 70
      ? commonStyles.batteryLightGreenColor
      : batteryValue > 40
        ? commonStyles.batteryLightYellowColor
        : commonStyles.batteryLightRedColor;

  if (roundedBatteryValue < 10) {
    roundedBatteryValue = 10;
  }
  /* let batteryIcon = {
        fontSize: "12px"
    };*/

  let batteryIconContainer = {
    transform: "translate(-7px,-40px) scale(1) translate(20px,20px)",
    height: "10px",
    width: "4px",
  };

  return (
    <div style={batteryIconContainer}>
      {roundedBatteryValue === 100 ? (
        <Icon
          font="MaterialCommunityIcons"
          name="battery"
          style={{ fontSize: "12px", color: batteryColor }}
        />
      ) : (
        <Icon
          font="MaterialCommunityIcons"
          name={`battery-${roundedBatteryValue}`}
          style={{ fontSize: "12px", color: batteryColor }}
        />
      )}
    </div>
  );
};

const BikeBatteryIcon = ({ batteryValue, style }) => {
  const batteryFillClass =
    batteryValue > 70
      ? "fi fi-battery-full battery--full"
      : batteryValue > 40
        ? "fi fi-battery-half battery-half"
        : batteryValue >= 0
          ? "fi fi-battery-empty battery--empty"
          : "fi fi-battery-full battery--empty";

  return (
    <i className={batteryFillClass} style={style}>
      {" "}
    </i>
  );
};

export const BikeBatteryLevel = ({ batteryValue, showPercentage, style }) => {
  if (batteryValue === null) {
    return <> </>;
  }
  return (
    <div style={{ ...style, flexDirection: "row", alignItems: "center" }}>
      <div style={{ marginRight: 2, float: "left" }}>
        <BikeBatteryIcon batteryValue={batteryValue} style={style} />
      </div>
      {showPercentage && (
        <span style={{ fontSize: 12, color: "black", paddingLeft: "5px" }}>{batteryValue}%</span>
      )}
    </div>
  );
};

export const LockBatteryLevel = ({ batteryValue, lockState, showPercentage, style, online }) => {
  if (batteryValue === null) {
    return <> </>;
  }
  let st = { marginRight: 2, float: "left" };
  let color = "#546e7a";
  if (online) {
    color = commonStyles.batteryLightGreenColor;
  }
  return (
    <>
      <div style={{ ...style, flexDirection: "row", alignItems: "center" }}>
        <div style={st}>
          <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 320 320">
            {lockState ? (
              lockState === "closed" ? (
                <g fill="#61DAFB">
                  <path d={ilockit.close} fill={color} />
                </g>
              ) : (
                <g fill={color}>
                  <path d={ilockit.open} />
                </g>
              )
            ) : (
              <g fill={color}>
                <path d={ilockit.close} />
              </g>
            )}
          </svg>
          <BatteryIcon batteryValue={batteryValue} />
        </div>
        {showPercentage && (
          <span style={{ fontSize: 12, color: "black", paddingLeft: "5px" }}>{batteryValue}%</span>
        )}
      </div>
    </>
  );
};
